import { FormattedMessage } from 'react-intl'

export default function SelectedOptions({ options, labelKey, idKey, onClick }) {
  return (
    <div className='selected-options'>
      {!options.length && (
        <span className='preferences no-preferences'>
          <FormattedMessage id='no_preference' defaultMessage='No preference' />
        </span>
      )}
      {options.map((option) => {
        const handleRemove = () => {
          onClick(option[idKey])
        }
        return (
          <span
            onClick={handleRemove}
            key={option[idKey]}
            className='preferences'
          >
            {option[labelKey]}
          </span>
        )
      })}
    </div>
  )
}
